import { combineReducers } from 'redux';
import categoriesReducer from './categoriesSlice';
import assetsReducer from './assetsSlice';

export default combineReducers({
  categories: categoriesReducer,
  assets: assetsReducer
})